import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CollectionService } from '@services/collection.service';
import { Subscription } from 'rxjs';
import { passwordValidator } from '../../shared/password.validator';
import { WebErrorService } from '@services/webError.service';

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.scss']
})
export class AddClientComponent implements OnInit {

  timeZoneData$: Subscription | undefined;
  timeZoneArr = [];
  clientForm: FormGroup;
  hide = true;
  constructor(private collectionService: CollectionService, private fb: FormBuilder, private webErrorService: WebErrorService) { }

  ngOnInit(): void {
    this.timeZoneData$ = this.collectionService.getTimeZone()?.subscribe((timeZoneData: any) => {
      this.timeZoneArr = timeZoneData?.items;
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
    this.clientForm = this.fb.group({
      clientName: ['', [Validators.required, Validators.minLength(2), Validators.pattern('^[a-zA-Z \-\']+')]],
      clientUrl: ['', [Validators.required, Validators.minLength(2)]],
      emailId: ['', [Validators.required, Validators.email]],
      timezone: ['', [Validators.required]],
      firstName: ['', [Validators.required, Validators.minLength(2), Validators.pattern('^[a-zA-Z \-\']+')]],
      lastName: ['', [Validators.required, Validators.minLength(2), Validators.pattern('^[a-zA-Z \-\']+')]],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(50)])],
      confirmPassword: ['', [Validators.required, passwordValidator]],

    });
  }
  get clientFormControl(): any {
    return this.clientForm.controls;
  }

  registerClient(): void {
    delete this.clientForm.value.confirmPassword;
    this.collectionService.registerClient(this.clientForm.value)?.subscribe(data => {
      alert('client registerd successfully');
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }
}
